<template>
    <div class="view downloads">
        <div class="section">
			<div class="title">
				<i class="icon ico-router"></i>
				<h4 class="section-title">Portal Cautivo</h4>
			</div>
            <div class="card-list">
                <DownloadCard class="dcard"
                title="Registros últimos 7 días"
                :initRange="initRange"
                :endRange="yesterday"
                :downloadType="0"
                dataDownload="/media/reporte_semanal.csv"/>
            </div>
            
		</div>
        <div class="section">
			<div class="title">
				<i class="icon ico-presence"></i>
				<h4 class="section-title">Presencia</h4>
			</div>
            <div class="card-list">
                <DownloadCard class="dcard"
                title="Resumen últimos 7 días"
                :initRange="initRange"
                :endRange="yesterday"
                :downloadType="1"/>
                <DownloadCard class="dcard"
                title="Resumen últimos 30 días"
                :initRange="initRange30"
                :endRange="yesterday"
                subtitle="del 10-Abr al 10-Jun"
                :downloadType="2"/>
            </div>
		</div>
        <div class="section">
			<div class="title">
				<i class="icon ico-api"></i>
				<h4 class="section-title">Clusters</h4>
			</div>
            <div class="card-list">
                <DownloadCard class="dcard"
                title="Resumen día de ayer"
                :initRange="yesterday"
                :endRange="yesterday"
                :downloadType="3"/>
                <DownloadCard class="dcard"
                title="Resumen últimos 7 días"
                :initRange="initRange"
                :endRange="yesterday"
                :downloadType="4"/>
                <DownloadCard class="dcard"
                title="Resumen últimos 30 días"
                :initRange="initRange30"
                :endRange="yesterday"
                :downloadType="5"/>
            </div>
		</div>
    </div>
</template>

<script>
import DownloadCard from '@/components/cards/DownloadCard'
import moment from 'moment'
export default {
    name: 'Downloads',
    components:{
        DownloadCard,
    },
    data: function(){
        return {
            initPrevious: moment().subtract(14,'d').format('YYYY-MM-DD'),
            endPrevious: moment().subtract(8, 'd').format('YYYY-MM-DD'),
            initRange: moment().subtract(7,'d').format('YYYY-MM-DD'),
            initRange15: moment().subtract(15, 'd').format('YYYY-MM-DD'),
            initPrevious15: moment().subtract(30, 'd').format('YYYY-MM-DD'),
            endPrevious15: moment().subtract(16, 'd').format('YYYY-MM-DD'),
            initRange30: moment().subtract(30, 'd').format('YYYY-MM-DD'),
            initPrevious30: moment().subtract(60, 'd').format('YYYY-MM-DD'),
            endPrevious30: moment().subtract(31, 'd').format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'd').format('YYYY-MM-DD'),
            }
    },
    mounted: function(){
        this.$store.dispatch("auth/setActive", "downloads");
    },
}

</script>

<style lang="sass">
.downloads
    .section
        grid-column: 2/6
        display: flex
        flex-direction: column
        margin-top: 8px
        @include mobile
            grid-column: 2/4
        @include mobile-landscape
            grid-column: 2/4
        @include tablet-portrait
            grid-column-start: 2
            grid-column-end: 6
    .section .title
        display: flex
        align-items: center
        width: 100%
        grid-column: 2/6
        .icon
            color: $white
            font-size: 24px
            margin: $xxs
            display: flex
            @include tablet-landscape
                font-size: 22px
            @include mobile
                font-size: 16px
            @include mobile-landscape
                font-size: 16px
        .section-title
            @include mobile
                width: 310px
                font-size: 16px
    .card-list
        width: 100%
        grid-column: 2/6
        margin-top: $sm
        display: flex
        flex-wrap: wrap
        @include mobile 
            grid-column: 2/4
        .dcard
            margin-left: 8px
            box-sizing: border-box
            margin-bottom: $xs
            &:first-child
                margin-left: 0px
            @include mobile
                &:nth-child(2n+1)
                    margin-left: 0px
            @include mobile-landscape
                &:nth-child(2n+1)
                    margin-left: 0px

</style>
